import React, { useCallback } from 'react';
import { Row, Col, Button, Modal } from 'react-bootstrap';

const ContactSupport = ({ onPopup, isPopupOpen }) => {
  const handleButtonPressed = useCallback(
    (event) => {
      onPopup(false);
    },
    [onPopup]
  );
  function Mailto({ email, subject, body, ...props }) {
    return <a href={`mailto:${email}?subject=${subject || ''}`}>{props.children}</a>;
  }

  return (
    <React.Fragment>
      <Modal show={isPopupOpen} onHide={() => handleButtonPressed()} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title as="h5">Contact Support</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Row>
            <Col sm={12}></Col>
            <Col sm={12}>
              <div className="form-group fill">
                <label className="floating-label" style={{ fontSize: '18px' }}>
                  For questions or need for technical support, please email{' '}
                  <label style={{ fontWeight: 'bold' }}> datamgt@emma-sleep.com </label>
                </label>
                <Mailto email="datamgt@emma-sleep.com" subject="Support for Emma Vendor Portal">
                  <label
                    style={{
                      fontWeight: 'bold',
                      fontSize: '18px',
                      color: '#1E2B5A',
                      cursor: 'pointer'
                    }}
                  >
                    Quik Mail!{' '}
                  </label>
                </Mailto>
              </div>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={() => handleButtonPressed()}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};
export default ContactSupport;
